import { securityKeys } from "../enums/SecurityKeys.ENUM";
import { getAuthProps } from "../utils/authentication/authLibrary";
import { encryptUrlData } from "../utils/encryption/CryptoService";

const authData = getAuthProps();
const organizationId = authData?.organizationId;

export const generalMenuItems = [
    {
        section: "Main Menu",
        items: [
            {
                id: 1,
                title: "Dashboard",
                icon: "pi pi-th-large",
                path: "/",
                securityKey: securityKeys.DASHBOARD ?? "Dashboard"
            },
            {
                id: 102,
                title: "Candidates",
                icon: "pi pi-id-card",
                subMenu: [
                    {
                        id: 2,
                        title: "Candidates",
                        path: "/applicants",
                        securityKey: securityKeys.APPLICANT ?? "Applicant",
                    },
                    {
                        id: 3,
                        title: "Follow-up Candidates",
                        path: "/applicants/follow-up",
                        securityKey: securityKeys.APPLICANT ?? "Follow-Up Applicants",
                    },
                    {
                        id: 5,
                        title: "Schedule Interview",
                        path: "/applicants/schedule",
                        securityKey: securityKeys.APPLICANT ?? "Schedule Interview",
                    },
                ]
            },
            {
                id: 104,
                title: "Interviews",
                icon: "pi pi-calendar",
                subMenu: [
                    {
                        id: 18,
                        title: "Interview Workflow",
                        path: "/interview-workflow",
                        securityKey: securityKeys.INTERVIEW_WORKFLOW ?? "Interview Workflow",
                    },
                    {
                        id: 6,
                        title: "My Scheduled Interviews",
                        path: "/my-interview/scheduled",
                        securityKey: securityKeys.SCHEDULED_INTERVIEWS ?? "Scheduled Interviews",
                    },
                    {
                        id: 7,
                        title: "Completed Interviews",
                        path: "/interview/completed",
                        securityKey: securityKeys.COMPLETED_INTERVIEWS ?? "Completed Interviews",
                    },
                    {
                        id: 33,
                        title: "My Interview Calendar",
                        path: "/my-interview/calendar",
                        securityKey: securityKeys.MY_INTERVIEW_CALENDAR ?? "My Interview Calendar",
                    },
                ]
            },
            {
                id: 101,
                title: "Recruitment",
                icon: "pi pi-briefcase",
                subMenu: [
                    {
                        id: 4,
                        title: "Job Requisition",
                        path: "/job-requisition",
                        securityKey: securityKeys.JOB_REQUISITION ?? "Job Requisition"
                    },
                    {
                        id: 33,
                        title: "Question Set",
                        path: "/questions",
                        securityKey: securityKeys.QUESTION_BANK
                    },
                    {
                        id: 34,
                        title: "Test Builder",
                        path: "/test-templates",
                        securityKey: securityKeys.TEST_TEMPLATE
                    },
                    {
                        id: 157,
                        title: "MolAssist",
                        path: "/recruitment-ai-assistant",
                        securityKey: securityKeys.RECRUITMENT_AI_ASSISTANT
                    },
                    {
                        id: 42,
                        title: "Dynamic Forms",
                        path: "/dynamic-forms",
                        securityKey: securityKeys.DYNAMIC_FORMS
                    },
                ]
            },
            {
                id: 107,
                title: "Job configuration",
                icon: "pi pi-cog",
                subMenu: [
                    {
                        id: 11,
                        title: "Job Openings",
                        path: "/job-opening",
                        securityKey: securityKeys.JOB_OPENINGS ?? "Job Openings",
                    },
                    {
                        id: 41,
                        title: "Job Description Templates",
                        path: "/job-description-templates",
                        securityKey: securityKeys.JOB_TEMPLATES ?? "Job Templates"
                    },
                ]
            },
            {
                id: 103,
                title: "Skill Setup",
                icon: "pi pi-microchip",
                subMenu: [
                    {
                        id: 25,
                        title: "Skill Categories",
                        path: "/skill-category",
                        securityKey: securityKeys.SKILL_CATEGORIES ?? "Skill Categories",
                    },
                    {
                        id: 26,
                        title: "Skills",
                        path: "/skills",
                        securityKey: securityKeys.SKILL_MANAGEMENT ?? "Skill Management",
                    },
                ]
            },
            {
                id: 105,
                title: "Resume Processing",
                icon: "pi pi-microchip-ai",
                subMenu: [
                    {
                        id: 8,
                        title: "Batch Resume Process",
                        path: "/batch-process",
                        securityKey: securityKeys.BATCH_RESUME_PROCESS ?? "Batch Resume Process",
                    },
                    {
                        id: 9,
                        title: "Parsed Resumes",
                        path: "/all-parsed-resumes",
                        securityKey: securityKeys.PARSED_RESUMES ?? "Parsed Resumes",
                    },
                ]
            },
            {
                id: 106,
                title: "Reports",
                icon: "pi pi-chart-bar",
                subMenu: [
                    {
                        id: 10,
                        title: "Candidate Report",
                        path: "/candidate-report",
                        // securityKey: securityKeys.LIST_CANDIDATE_REPORT ?? "Candidate Report",
                        isReport: true
                    },
                    {
                        id: 11,
                        title: "Job Report",
                        path: "/job-report",
                        // securityKey: securityKeys.JOB_REPORT ?? "Job Report",
                        isReport: true
                    },
                    {
                        id: 12,
                        title: "Activity Log Report",
                        path: "/activity-log-report",
                        // securityKey: securityKeys.ACTIVITY_LOG_REPORT ?? "Activity Log Report",
                        isReport: true
                    },
                ]
            },
            {
                id: 108,
                title: "Form Associations",
                icon: "pi pi-file-edit",
                subMenu: [
                    {
                        id: 13,
                        title: "Form Associations",
                        path: "/form-associations",
                        securityKey: securityKeys.FORM_ASSOCIATIONS ?? "Form Associations",
                    }
                ]
            },
        ]
    }
];

export const adminMenuItems = [
    {
        section: "Admin Setup",
        items: [
            {
                id: 201,
                title: "Organization Setup",
                icon: "pi pi-building",
                subMenu: [
                    {
                        id: 13,
                        title: "Organization Profile",
                        path: `/organization-details/${encryptUrlData(organizationId)}`,
                        securityKey: securityKeys.MANAGE_ORGANIZATION ?? "Manage Organization",
                    },
                    {
                        id: 14,
                        title: "Departments",
                        path: "/department",
                        securityKey: securityKeys.MANAGE_DEPARTMENTS ?? "Manage Departments",
                    },
                ]
            },
            {
                id: 202,
                title: "User & Access Control",
                icon: "pi pi-users",
                subMenu: [
                    {
                        id: 15,
                        title: "Users",
                        path: "/users",
                        securityKey: securityKeys.MANAGE_USERS ?? "Manage Users",
                    },
                    {
                        id: 16,
                        title: "Roles",
                        path: "/roles",
                        securityKey: securityKeys.MANAGE_ROLES ?? "Manage Roles",
                    },
                    {
                        id: 17,
                        title: "Security & Permissions",
                        path: "/security",
                        securityKey: securityKeys.SECURITY ?? "Security",
                    },
                ]
            },
            {
                id: 203,
                title: "Recruitment Setup",
                icon: "pi pi-sliders-h",
                subMenu: [
                    {
                        id: 18,
                        title: "Interview Workflow",
                        path: "/interview-workflow",
                        securityKey: securityKeys.INTERVIEW_WORKFLOW ?? "Interview Workflow",
                    },
                    {
                        id: 19,
                        title: "Interview Rounds",
                        path: "/interview-round",
                        securityKey: securityKeys.INTERVIEW_ROUND ?? "Interview Round",
                    },
                    {
                        id: 20,
                        title: "Interview Types",
                        path: "/interview-type",
                        securityKey: securityKeys.INTERVIEW_TYPE ?? "Interview Type",
                    },
                    {
                        id: 21,
                        title: "Candidate Status",
                        path: "/applicant-status",
                        securityKey: securityKeys.MANAGE_APPLICANT_STATUS ?? "Manage Applicant Status",
                    },
                    {
                        id: 22,
                        title: "Employment Types",
                        path: "/employment-types",
                        securityKey: securityKeys.EMPLOYMENT_TYPES ?? "Employment Types",
                    },
                    {
                        id: 23,
                        title: "Rejection Reasons",
                        path: "/rejected-reason",
                        securityKey: securityKeys.REJECTED_REASON ?? "Rejected Reason",
                    },
                    {
                        id: 24,
                        title: "Follow-up Reasons",
                        path: "/followup-reason",
                        securityKey: securityKeys.FOLLOWUP_REASON ?? "Followup Reason",
                    },
                    {
                        id: 40,
                        title: "Job Description Templates",
                        path: "/job-description-templates",
                        securityKey: securityKeys.JOB_TEMPLATES ?? "Job Templates"
                    }
                ]
            },
            {
                id: 204,
                title: "Source Setup",
                icon: "pi pi-share-alt",
                subMenu: [
                    {
                        id: 27,
                        title: "Channels",
                        path: "/channel",
                        securityKey: securityKeys.MANAGE_CHANNEL ?? "Manage Channel",
                    },
                    {
                        id: 28,
                        title: "Sources",
                        path: "/source",
                        securityKey: securityKeys.MANAGE_SOURCE ?? "Manage Source",
                    },
                ]
            },
            {
                id: 205,
                title: "Communication Setup",
                icon: "pi pi-envelope",
                subMenu: [
                    {
                        id: 29,
                        title: "Email Templates",
                        path: "/email-template",
                        securityKey: securityKeys.MANAGE_EMAIL_TEMPLATE ?? "Manage Email Template",
                    },
                    {
                        id: 43,
                        title: "Notification Center",
                        path: "/notifications",
                        securityKey: securityKeys.MANAGE_NOTIFICATIONS ?? "Manage Notifications",
                    },
                ]
            },
            {
                id: 206,
                title: "Approval Setup",
                icon: "pi pi-check-square",
                subMenu: [
                    {
                        id: 30,
                        title: "Approval Workflow",
                        path: "/approval-workflow",
                        securityKey: securityKeys.APPROVAL_CONFIGURATION ?? "Approval Configuration",
                    },
                ]
            },
            {
                id: 207,
                title: "Report Setup",
                icon: "pi pi-cog",
                subMenu: [
                    {
                        id: 31,
                        title: "Report Configuration",
                        path: "/manage-reports",
                        securityKey: securityKeys.MANAGE_REPORTS ?? "Manage Reports",
                    },
                ]
            },
            {
                id: 209,
                title: "AI Control Center",
                        icon: "pi pi-sparkles",
                        subMenu: [
                            {
                                id: 41,
                                title: "Overview",
                                path: "/ai-control-center",
                                securityKey: securityKeys.AI_CONTROL_CENTER ?? "AI Control Center",
                            },
                            {
                                id: 42,
                                title: "Providers",
                                path: "/ai-providers",
                                securityKey: securityKeys.AI_CONTROL_CENTER ?? "AI Control Center",
                            },
                            {
                                id: 44,
                                title: "Features",
                                path: "/ai-features",
                                securityKey: securityKeys.AI_CONTROL_CENTER ?? "AI Control Center",
                            },
                            {
                                id: 45,
                                title: "Feature Config",
                                path: "/ai-feature-config",
                                securityKey: securityKeys.AI_CONTROL_CENTER ?? "AI Control Center",
                            },
                            {
                                id: 43,
                                title: "Prompt Library",
                                path: "/ai-prompt-library",
                                securityKey: securityKeys.AI_CONTROL_CENTER ?? "AI Control Center",
                            },
                            {
                                id: 46,
                                title: "Execution / Usage",
                                path: "/ai-execution-logs",
                                securityKey: securityKeys.AI_CONTROL_CENTER ?? "AI Control Center",
                            },
                        ]
            },
            {
                id: 208,
                title: "System Setup",
                icon: "pi pi-sliders-v",
                subMenu: [
                    {
                        id: 32,
                        title: "System Actions",
                        path: "/system-actions",
                        securityKey: securityKeys.SYSTEM_ACTIONS ?? "System Actions",
                    },
                ]
            }
        ]
    }
];
